import React, { useState, useEffect } from 'react';
import ReactHowler from 'react-howler';
import StoryModal from './StoryModal';
import SocialModal from './SocialModal';
import TokenomicsModal from './TokenomicsModal';

const DiscoPanda: React.FC = () => {
    const [bgColor, setBgColor] = useState('rgba(138, 43, 226, 0.3)');
    const [isStoryModalOpen, setIsStoryModalOpen] = useState(false);
    const [isSocialModalOpen, setIsSocialModalOpen] = useState(false);
    const [isTokenomicsModalOpen, setIsTokenomicsModalOpen] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            const colors = [
                'rgba(255, 20, 147, 0.4)', // funky-pink
                'rgba(255, 215, 0, 0.4)',  // funky-yellow
                'rgba(0, 191, 255, 0.4)',  // funky-blue
                'rgba(50, 205, 50, 0.4)'   // funky-green
            ];
            setBgColor(colors[Math.floor(Math.random() * colors.length)]);
        }, 150);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="min-h-screen w-full flex flex-col items-center justify-center relative"
            style={{ backgroundImage: 'url(/assets/panda_bg.webp)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <ReactHowler src="/assets/panda.mp3" playing={true} loop={true} />
            <div className="absolute inset-0" style={{ backgroundColor: bgColor, transition: 'background-color 0.2s ease' }}></div>

            {/* <h1 className="text-6xl font-funky mb-8 text-funky-yellow z-10 text-center">
                DISCO PANDA
            </h1> */}

            <div className='flex md:flex-row flex-col items-center justify-center md:gap-20 gap-5 fixed bottom-10 left-1/2 -translate-x-1/2'>
                <button
                    className="transform px-8 py-3 bg-gradient-to-r from-funky-pink to-funky-yellow text-funky-blue font-funky rounded-full text-3xl hover:from-funky-yellow hover:to-funky-pink transition-all duration-300 z-20 animate-float"
                    onClick={() => setIsSocialModalOpen(true)}
                >
                    JOIN
                </button>
                <button
                    className="transform whitespace-nowrap px-6 py-3 bg-gradient-to-r from-funky-blue to-funky-green text-funky-yellow font-funky rounded-full text-3xl hover:from-funky-green hover:to-funky-blue transition-all duration-300 z-20 animate-float"
                    onClick={() => setIsStoryModalOpen(true)}
                >
                    The Story
                </button>
                <button
                    className="transform px-6 py-3 bg-gradient-to-r from-funky-pink to-funky-yellow text-funky-blue font-funky rounded-full text-3xl hover:from-funky-yellow hover:to-funky-pink transition-all duration-300 z-20 animate-float"
                    onClick={() => setIsTokenomicsModalOpen(true)}
                >
                    Tokenomics
                </button>
            </div>

            {isStoryModalOpen && <StoryModal onClose={() => setIsStoryModalOpen(false)} />}
            {isSocialModalOpen && <SocialModal onClose={() => setIsSocialModalOpen(false)} />}
            {isTokenomicsModalOpen && <TokenomicsModal onClose={() => setIsTokenomicsModalOpen(false)} />}
        </div>
    );
};

export default DiscoPanda;